import { useEffect, useState } from "react";
import About from "../../components/home/About";
import Banner from "../../components/home/Banner";
import Blog from "../../components/home/Blog";
import Event from "../../components/home/Event";
import Service from "../../components/home/Service";
import axios from "axios";
import Review from "../../components/home/Review";
import Partners from "../../components/home/Partners";
import Chart from "../../components/home/Chart";
import Contact from "../../components/home/Contact";
import useScript from "../../const/useScript";

const Transform = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    axios.get("/api/blog").then((res) => setData(res.data.data));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useScript("https://www.googletagmanager.com/gtag/js?id=AW-18050995569");

  useEffect(() => {
    const google = document.createElement("script");
    google.async = true;
    google.innerHTML = `gtag('event', 'conversion', { 'send_to': 'AW-18050995569/T4w9CN_S6pIcEPGqsZ9D', 'value': 1.0, 'currency': 'KRW' });`;

    document.body.appendChild(google);
    return () => {
      document.body.removeChild(google);
    };
  }, []);
  return (
    <div>
      <Banner />
      <About />
      <Service />
      <Chart />
      <Blog data={data} />
      <Event />
      <Review />
      <Contact />
      <Partners />
    </div>
  );
};

export default Transform;
